














































































































































import Vue from "vue";
import moment from "moment";
import restaurantsService from "@/services/restaurants-service";
import Restaurant from "./models/Restaurant";
import axios from "@/axios";

export default Vue.extend({
  name: "App",

  data: () => ({
    drawer: null,
    sheet: false,
    isOpened: true,
    today: moment().format("DD.MM.yyyy"),
    restaurant: new Restaurant()
  }),

  methods: {
    toggleOpenClosed() {
      this.sheet = !this.sheet;
    },

    async openRestaurant() {
      if (
        await restaurantsService.updateDisabledAsync(this.restaurant.uid, 0)
      ) {
        this.isOpened = !this.isOpened;
        setTimeout(() => {
          this.sheet = false;
        }, 500);
      }
    },

    async closeRestaurant() {
      if (
        await restaurantsService.updateDisabledAsync(this.restaurant.uid, 1)
      ) {
        this.isOpened = !this.isOpened;
        setTimeout(() => {
          this.sheet = false;
        }, 500);
      }
    },

    async getRestaurantAsync() {
      return (
        (await restaurantsService.findOneAsync(Vue.prototype.$uid)) ??
        new Restaurant()
      );
    },

    async updateOpenClosedStateAsync() {
      let restaurant = await this.getRestaurantAsync();
      this.isOpened = restaurant.disabled == 0;
    }
  },

  async created() {
    Vue.prototype.$apiKey = process.env.VUE_APP_API_KEY;
    Vue.prototype.$uid = process.env.VUE_APP_RESTAURANT_UID;
    let key = localStorage.getItem("apiKey");
    if (key) {
      Vue.prototype.$apiKey = key;
    }
    let uid = localStorage.getItem("uid");
    if (uid) {
      Vue.prototype.$uid = uid;
    }
  },

  async mounted() {
    setInterval(() => { this.updateOpenClosedStateAsync() }, 60000);
    await this.updateOpenClosedStateAsync();
    this.restaurant = await this.getRestaurantAsync();
    if (!this.restaurant.logo) {
      this.restaurant.logo = "img/placeholder-logo.png";
    } else {
      this.restaurant.logo = "//" + this.restaurant.logo;
    }
  }
});
